export default __webpack_public_path__ + "static/media/primary.4dfe0dc54b1858703ec4c6be0a57482a.svg";